import useExperimentalFeature from 'hooks/useExperimentalFeature';
import { isHybridSearchFlagEnabled } from 'utils/search/hybridSearchFlag';

/**
 * Resolve the `HYBRID_SEARCH_ENABLED` experimental feature to a boolean.
 * @returns {boolean} Whether hybrid search is enabled for the current brand.
 */
const useHybridSearchEnabled = () =>
  isHybridSearchFlagEnabled(useExperimentalFeature('HYBRID_SEARCH_ENABLED'));

export default useHybridSearchEnabled;
